// extracted by mini-css-extract-plugin
export default {"slowResponder":"slowResponderBadge_slowResponder__ROcLJ"};